export type ChipOption = {
  id: string;
  label: string;
  exclusive?: boolean;
};

/**
 * Toggle a chip selection with exclusive-option logic.
 * Returns a new Set with the updated selection.
 */
export function toggleChipSelection(
  prev: Set<string>,
  optionId: string,
  options: ChipOption[],
): Set<string> {
  const clicked = options.find((opt) => opt.id === optionId);
  const isExclusive = clicked?.exclusive ?? false;
  const next = new Set(prev);

  if (isExclusive) {
    if (next.has(optionId)) {
      next.delete(optionId);
    } else {
      next.clear();
      next.add(optionId);
    }
  } else {
    for (const opt of options) {
      if (opt.exclusive) next.delete(opt.id);
    }
    if (next.has(optionId)) {
      next.delete(optionId);
    } else {
      next.add(optionId);
    }
  }

  return next;
}
